export default "__VITE_ASSET__3f79a54a__"